"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBlueprintCreation = isBlueprintCreation;
exports.isBlueprintReplacement = isBlueprintReplacement;
exports.isBlueprintUpdate = isBlueprintUpdate;
exports.isBlueprintRemoval = isBlueprintRemoval;
exports.isBlueprintReorder = isBlueprintReorder;
exports.isSectionBlueprintCreation = isSectionBlueprintCreation;
exports.isSubsectionBlueprintCreation = isSubsectionBlueprintCreation;
exports.isFieldGroupBlueprintCreation = isFieldGroupBlueprintCreation;
exports.isFieldBlueprintCreation = isFieldBlueprintCreation;
exports.isSelectOptionBlueprintCreation = isSelectOptionBlueprintCreation;
exports.isSectionGroupBlueprintUpdate = isSectionGroupBlueprintUpdate;
exports.isSectionBlueprintUpdate = isSectionBlueprintUpdate;
exports.isSubsectionBlueprintUpdate = isSubsectionBlueprintUpdate;
exports.isFieldGroupBlueprintUpdate = isFieldGroupBlueprintUpdate;
exports.isFieldBlueprintUpdate = isFieldBlueprintUpdate;
exports.isSelectOptionBlueprintUpdate = isSelectOptionBlueprintUpdate;
exports.isSectionBlueprintReorder = isSectionBlueprintReorder;
exports.isSubsectionBlueprintReorder = isSubsectionBlueprintReorder;
exports.isFieldGroupBlueprintReorder = isFieldGroupBlueprintReorder;
exports.isFieldBlueprintReorder = isFieldBlueprintReorder;
exports.isSelectOptionBlueprintReorder = isSelectOptionBlueprintReorder;
const blueprintIdentifiers_1 = require("./blueprintIdentifiers");
function isBlueprintCreation(modification) {
    return !!modification.create;
}
function isBlueprintReplacement(modification) {
    return !!modification.replacement;
}
function isBlueprintUpdate(modification) {
    return !!modification.update;
}
function isBlueprintRemoval(modification) {
    return !!modification.remove;
}
function isBlueprintReorder(modification) {
    return !!modification.reorder;
}
function isSectionBlueprintCreation(blueprintCreation) {
    // Don't need to specify a parent item when creating a section.
    return blueprintCreation.partIdentifier === null;
}
function isSubsectionBlueprintCreation(blueprintCreation) {
    // Container elements are specified when creating a sub-item.
    return (0, blueprintIdentifiers_1.isSectionPartIdentifier)(blueprintCreation.partIdentifier);
}
function isFieldGroupBlueprintCreation(blueprintCreation) {
    // Container elements are specified when creating a sub-item.
    return (0, blueprintIdentifiers_1.isSubsectionPartIdentifier)(blueprintCreation.partIdentifier);
}
function isFieldBlueprintCreation(blueprintCreation) {
    // Container elements are specified when creating a sub-item.
    return (0, blueprintIdentifiers_1.isFieldGroupPartIdentifier)(blueprintCreation.partIdentifier);
}
function isSelectOptionBlueprintCreation(blueprintCreation) {
    // Container elements are specified when creating a sub-item.
    return (0, blueprintIdentifiers_1.isFieldPartIdentifier)(blueprintCreation.partIdentifier);
}
function isSectionGroupBlueprintUpdate(blueprintUpdate) {
    return (0, blueprintIdentifiers_1.isSectionGroupPartIdentifier)(blueprintUpdate.partIdentifier);
}
function isSectionBlueprintUpdate(blueprintUpdate) {
    return (0, blueprintIdentifiers_1.isSectionPartIdentifier)(blueprintUpdate.partIdentifier);
}
function isSubsectionBlueprintUpdate(blueprintUpdate) {
    return (0, blueprintIdentifiers_1.isSubsectionPartIdentifier)(blueprintUpdate.partIdentifier);
}
function isFieldGroupBlueprintUpdate(blueprintUpdate) {
    return (0, blueprintIdentifiers_1.isFieldGroupPartIdentifier)(blueprintUpdate.partIdentifier);
}
function isFieldBlueprintUpdate(blueprintUpdate) {
    return (0, blueprintIdentifiers_1.isFieldPartIdentifier)(blueprintUpdate.partIdentifier);
}
function isSelectOptionBlueprintUpdate(blueprintUpdate) {
    return (0, blueprintIdentifiers_1.isSelectOptionPartIdentifier)(blueprintUpdate.partIdentifier);
}
function isSectionBlueprintReorder(blueprintReorder) {
    return (0, blueprintIdentifiers_1.isSectionPartIdentifier)(blueprintReorder.partIdentifier);
}
function isSubsectionBlueprintReorder(blueprintReorder) {
    return (0, blueprintIdentifiers_1.isSubsectionPartIdentifier)(blueprintReorder.partIdentifier);
}
function isFieldGroupBlueprintReorder(blueprintReorder) {
    return (0, blueprintIdentifiers_1.isFieldGroupPartIdentifier)(blueprintReorder.partIdentifier);
}
function isFieldBlueprintReorder(blueprintReorder) {
    return (0, blueprintIdentifiers_1.isFieldPartIdentifier)(blueprintReorder.partIdentifier);
}
function isSelectOptionBlueprintReorder(blueprintReorder) {
    return (0, blueprintIdentifiers_1.isSelectOptionPartIdentifier)(blueprintReorder.partIdentifier);
}
